export class GmcCvFilterService {
  static $inject = [];

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./app/shared/components/gmc-cv-filter/gmc-cv-filter.service.ts